import { useAppSelector } from '@/redux/hooks';
import { getSearchCorrectedTerm } from '@/redux/modules/search/search.selectors';

type SpellCorrectionTerms = {
    correctedSearchTerm: string;
    originalSearchTerm: string;
};

type UseSpellCorrectionTermsParams = {
    isLoadingSearchResults: boolean;
    /**
     * The keyword as the person typed it, from the URL's `originalKeyword` once the page swapped `keyword` for
     * search-party's correction.
     */
    originalSearchTerm?: string;
    searchTerm: string;
};

/**
 * The corrected and typed keywords when the page shows corrected results, for the "Search instead for" message.
 */
export const useSpellCorrectionTerms = ({
    isLoadingSearchResults,
    originalSearchTerm,
    searchTerm,
}: UseSpellCorrectionTermsParams): SpellCorrectionTerms | undefined => {
    const storedCorrectedSearchTerm = useAppSelector((state) => getSearchCorrectedTerm(state, searchTerm));

    if (originalSearchTerm) {
        return { correctedSearchTerm: searchTerm, originalSearchTerm };
    }
    // Until the page swaps the URL (the server render) only the stored correction knows the results were corrected.
    // While the same keyword re-runs (paging, sort) it may not describe the next response.
    if (storedCorrectedSearchTerm && !isLoadingSearchResults) {
        return { correctedSearchTerm: storedCorrectedSearchTerm, originalSearchTerm: searchTerm };
    }
    return undefined;
};
